<template>
    <div>
        <el-form :model="parentInfo.component_storeClassPlan.classPlanForm" label-width="80px">
            <el-form-item label="任课老师:">
                <el-select v-model="parentInfo.component_storeClassPlan.classPlanForm.teacher_id"
                           style="width: 200px"
                           filterable placeholder="请选择"
                           @change="changeTeacher()">
                    <el-option
                            v-for="item in parentInfo.component_storeClassPlan.teachers"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="时长:">
                <el-input v-model="parentInfo.component_storeClassPlan.classPlanForm.duration" style="width: 200px"></el-input>
            </el-form-item>
            <el-form-item label="开始时间:">
                <el-time-select
                        style="width: 200px"
                        placeholder="起始时间"
                        v-model="parentInfo.component_storeClassPlan.classPlanForm.start_time"
                        :picker-options="{
                          start: '08:00',
                          step: '00:10',
                          end: '22:00'
                        }">
                </el-time-select>
            </el-form-item>
            <el-form-item>
                <el-button  size="small" @click="handleStore()" :loading="parentInfo.component_storeClassPlan.button_loading">提交添加</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    export default {
        name: "StoreClassPlan",
        data() {
            return {
                title: '增加课次',
            }
        },
        created() {
            this.parentInfo = this.$parent.$parent.$parent.$parent;
            this.handleGetTeachers('');
        },
        props: {
            datax:{},
        },
        methods: {
            changeTeacher(){
                const teacher_id= this.parentInfo.component_storeClassPlan.classPlanForm.teacher_id
                this.handleGetTeachers(teacher_id);
            },
            handleGetTeachers(teacher_id){
                this.$wApi.send(this.parentInfo.path, 'get_classPlanContent', {
                    'class_id': this.datax.class_id,
                    'teacher_id': teacher_id,
                    'date':this.datax.date
                });
            },
            handleStore(){
                this.parentInfo.component_storeClassPlan.button_loading=true;
                this.$wApi.send(this.parentInfo.path, 'store_classPlan', {
                    'class_id': this.datax.class_id,
                    'teacher_id': this.parentInfo.component_storeClassPlan.classPlanForm.teacher_id,
                    'date':this.datax.date,
                    'start_time':this.parentInfo.component_storeClassPlan.classPlanForm.start_time,
                });
            },
        }
    }
</script>

<style scoped>
    .modal {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 99999;
    }

    .modal-dialog {
        max-width: 500px;
        margin: 30px auto;
    }

    .modal-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 15px;
        border-bottom: 1px solid #e9ecef;
    }

    .modal-header {
        font-size: 12px;
    }

    .modal-title {
        margin: 0;
        line-height: 1.5;
    }

    .modal-body {
        position: relative;
        flex: 1 1 auto;
        padding: 15px;
    }

    .modal-content {
        position: relative;
        display: flex;
        flex-direction: column;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid rgba(0, 0, 0, .18);
        border-radius: .3rem;
        outline: 0;
        min-height: 300px;
        box-shadow: 0px 0px 20px 2px rgba(0, 0, 0, 0.12);
    }

    .modal .close {
        font-size: 20px;
        text-shadow: 0 1px 0 #fff;
    }

    .modal .close:hover {
        opacity: .5;
    }
</style>
